import Utils from '../../../scripts/vendors/utils';

/**
 * Blog
 * @class
 * @constructor
 * @public
 */
class Blog {
  /**
   * Constructor
   * @returns {class}
   */
  constructor(lazyLoadInstance) {
    this.component = document.querySelector('[data-blog]');
    this.lazyLoadInstance = lazyLoadInstance;
    this.isLoading = false;

    // Engage engines

    if (this.component) {

      // Elements
      this.loadMoreContainer = this.component.querySelector('[data-blog-loadmore]');
      this.itemsContainer = this.component.querySelector('[data-blog-container]');
      this.loadMoreForm = this.component.querySelector('[data-blog-loadmore-form]');
      this.loadMoreButton = this.component.querySelector('[data-blog-loadmore-button]');
      this.queryLimitField = this.component.querySelector('input[name="limit"]');
      this.queryOffsetField =this.component.querySelector('input[name="offset"]');

      if (this.loadMoreForm) {
        this.init();
      }
    }
  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init() {
    this.loadMoreForm.addEventListener('submit', this.loadMore.bind(this));
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  /**
   * Trigger animations when elements are in viewport
   * @returns {void}
   */
  onScroll() {
    if (Utils.intersect.isElementInViewport(this.loadMoreForm, 30)) {
      this.loadMore(false);
    }
  }

  /**
   * Load more entries
   * @returns {void}
   */
  loadMore(e) {
    if (e) {
      e.preventDefault();
    }

    if (!this.isLoading && this.component.querySelector('[data-blog-loadmore]')) {
      this.loadMoreButton.setAttribute('disabled', 'true');
      this.component.classList.add('is-loading');
      this.isLoading = true;

      const that = this;

      fetch(this.loadMoreForm.getAttribute('action'), {
        method: 'POST',
        body: new FormData(this.loadMoreForm)
      })
        .then(response => response.json())
        .then((data) => {
          data.entries.forEach((entry) => {
            const newDomNode = document.createElement('div');
            newDomNode.innerHTML = entry.replace(/\\"/g, '"\""');
            while (newDomNode.firstChild) {
              that.itemsContainer.appendChild(newDomNode.firstChild);
            }
          });

          this.component.classList.remove('is-loading');
          that.loadMoreButton.removeAttribute('disabled');
          that.lazyLoadInstance.update();

          if (!data.hasMore) {
            that.loadMoreContainer.parentNode.removeChild(that.loadMoreContainer);
          } else {
            that.queryOffsetField.value = parseInt(that.queryOffsetField.value) + parseInt(that.queryLimitField.value);
          }

          this.isLoading = false;
        });
    }

  }

}

module.exports = Blog;
